import { makeEnumClass } from '../base-enum';

export class SituacaoExercicioFeriasEnum extends makeEnumClass() {
    static readonly NAO_SOLICITADA = SituacaoExercicioFeriasEnum.add('NSL', 'Não Solicitada');
    static readonly SOLICITADA = SituacaoExercicioFeriasEnum.add('SOL', 'Solicitada');
    static readonly HOMOLOGADA = SituacaoExercicioFeriasEnum.add('HOM', 'Homologada');
    static readonly CONCLUIDA = SituacaoExercicioFeriasEnum.add('CON', 'Concluída');
    static readonly ENCERRADA = SituacaoExercicioFeriasEnum.add('ENC', 'Encerrada');
    static readonly INTERROMPIDA = SituacaoExercicioFeriasEnum.add('INT', 'Interrompida');
}
